import { render, staticRenderFns } from "./editRegulation.vue?vue&type=template&id=3b97f246&scoped=true"
import script from "./editRegulation.vue?vue&type=script&lang=js"
export * from "./editRegulation.vue?vue&type=script&lang=js"
import style0 from "./editRegulation.vue?vue&type=style&index=0&id=3b97f246&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97f246",
  null
  
)

export default component.exports